import { Check, ContentCopy } from '@mui/icons-material';
import { IconButton } from '@mui/material';
import { mergeSx } from 'merge-sx';
import React, { useCallback, useState } from 'react';
import { handleCopy } from './handleCopy';
import { copyIconStyle } from './styles';
import { Color } from 'shared/utils/colors';

export const CopyTextIcon = ({
  value,
  setOpenSnackbar,
}: {
  value: string;
  setOpenSnackbar: (open: boolean) => void;
}): React.ReactElement => {
  const [copied, setCopied] = useState(false);

  const onCopy = useCallback(async () => {
    await handleCopy(value, setOpenSnackbar);
    setCopied(true);
    window.setTimeout(() => setCopied(false), 1500);
  }, [value, setOpenSnackbar]);

  return (
    <IconButton
      size='small'
      onClick={onCopy}
      className='copy-icon'
      sx={mergeSx(
        copyIconStyle,
        copied && {
          '& .MuiSvgIcon-root': { color: Color.accentGreen600 },
        }
      )}
    >
      {copied ? <Check /> : <ContentCopy />}
    </IconButton>
  );
};
